import { useEffect } from "react";
import { useSyncExternalStore } from "react";
import api from "./api";
import {
    setDealerQuickCounts,
    getDealerQuickCounts,
    subscribeDealerQuickCounts,
} from "./dealerQuickCountsStore";

/**
 * Jun-2026 (User-Wunsch) — Live-Badge-Zähler für die Mobile-Schnellzugriff-Kacheln.
 * Initial-Fetch beim Aktivieren (B2B-Händler), danach Live-Update über den
 * externen Store (gespeist von WebSocket-Events in `useUserNotifications`).
 * Liefert {workshop_open, inventory_uncounted}.
 */
export default function useDealerQuickCounts(enabled) {
    useEffect(() => {
        if (!enabled) return;
        let active = true;
        api.get("/dealer/quick-counts")
            .then((r) => { if (active && r.data) setDealerQuickCounts(r.data); })
            .catch(() => {});
        return () => { active = false; };
    }, [enabled]);

    return useSyncExternalStore(subscribeDealerQuickCounts, getDealerQuickCounts, getDealerQuickCounts);
}
